import React, { createContext, useContext, useEffect } from 'react';
import { useRestaurant } from './RestaurantContext';
import { directory } from '../constants';
import restaurantSpecificTranslation from '../translations/restaurantSpecificTranslation.json';
const LanguageContext = createContext({});
export const useLanguage = () => useContext(LanguageContext);

const LanguageContextProvider = ({ children }) => {
    const response = localStorage.getItem('lang') || 'en';
    const [lang, setLang] = React.useState(response);
    const [langList, setLangList] = React.useState([]);
    const [translation, setTranslation] = React.useState({});
    const { restaurantDetails } = useRestaurant();

    React.useEffect(() => {
        const response = localStorage.getItem('lang') || 'en';
        changeHTMLDirection(response);
        setLang(response);
    }, []);
    useEffect(() => {
        if (restaurantDetails.languages && restaurantDetails.languages.length) {
            setLangList(restaurantDetails.languages);
        }
    }, [restaurantDetails, restaurantDetails.languages]);

    React.useEffect(() => {
        let code = lang ?? 'en';
        changeHTMLDirection(code);
        const getTranslation = directory[code] || {};
        const restaurantID = restaurantDetails.id;
        const propertyObj = restaurantSpecificTranslation[restaurantID] || {};
        const selectedLangtranslation = propertyObj[code] || {};
        const finalTranslation = {
            ...getTranslation,
            ...selectedLangtranslation,
        };
        setTranslation(finalTranslation);
    }, [lang, restaurantDetails.id]);

    React.useEffect(() => {
        const updateLanguage = () => {
            try {
                const response = localStorage.getItem('lang') || 'en';
                setLang(response);
            } catch (error) {}
        };

        updateLanguage();
    }, []);

    const changeHTMLDirection = (code) => {
        if (code === 'ar') {
            document.body.setAttribute('dir', 'rtl');
        } else {
            document.body.setAttribute('dir', 'ltr');
        }
    };
    // const renderText = (key) => {
    //     const value = translation[key]
    //     return value;
    // };
    const updateLocalStorage = async (lang) => {
        try {
            await localStorage.setItem('lang', lang);
        } catch (error) {}
    };
    const changeLanguage = (newlang, reloadApp) => {
        setLang(newlang);
        updateLocalStorage(newlang);
        if (reloadApp) window.location.reload();
    };


    const value = {
        changeLanguage,
        lang,
        langList,
        t: translation,
    };
    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export default LanguageContextProvider;
